module.exports = __webpack_public_path__ + "img/motorcycle-photo-01.5c7938a7.jpg";